import { GrassIcon } from './GrassIcon';

/**
 * author: Google
 * id 8688646A-F06F-421F-83B1-8AA8FABF7BD8
 * name grass
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/grass.svg
 * tags
 * - Nature 
 * - Agriculture 
 */
export const LawnIcon = GrassIcon;
export default LawnIcon